import { api, ReactQueryOptions, RouterInputs } from '@api'
import { useSession } from '@shared/hooks/useSession'

type useToyActiveDropsOptions = ReactQueryOptions['DropManager']['getToyActiveDrops']
type useToyActiveDropsInput = RouterInputs['DropManager']['getToyActiveDrops']

export const useToyActiveDrops = (input: useToyActiveDropsInput, options?: useToyActiveDropsOptions) => {
    const { status } = useSession()

    return api.DropManager.getToyActiveDrops.useQuery(input, {
        ...options,
        queryKey: ['DropManager.getToyActiveDrops', input],
        enabled: status === 'authenticated' && !!input.toyId,
        staleTime: 2 * 60 * 1000, // 2 mins
    })
}
